import {
  IPartnerApp,
  IPartnerAppAccessToken,
  IPartnerAppAuthorisationCode,
  IWebhook,
  PartnerAppCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  all$,
  AtLeast,
  CollectionReference,
  IReffable,
  subCollection,
  uid,
  undeletedQuery,
  WithRef,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';

export class PartnerApp {
  static init(overrides: AtLeast<IPartnerApp, 'name'>): IPartnerApp {
    return {
      deleted: false,
      oauth: {
        clientId: uid(true),
        clientSecrets: [],
        redirectUri: '',
        scopes: [],
      },
      ...overrides,
    };
  }

  static webhookCol(
    app: IReffable<IPartnerApp>
  ): CollectionReference<IWebhook> {
    return subCollection<IWebhook>(app, PartnerAppCollection.Webhooks);
  }

  static webhooks$(
    app: IReffable<IPartnerApp>
  ): Observable<WithRef<IWebhook>[]> {
    return all$(undeletedQuery(PartnerApp.webhookCol(app)));
  }

  static authorisationCodeCol(
    app: IReffable<IPartnerApp>
  ): CollectionReference<IPartnerAppAuthorisationCode> {
    return subCollection<IPartnerAppAuthorisationCode>(
      app,
      PartnerAppCollection.AuthorisationCodes
    );
  }

  static accessTokenCol(
    app: IReffable<IPartnerApp>
  ): CollectionReference<IPartnerAppAccessToken> {
    return subCollection<IPartnerAppAccessToken>(
      app,
      PartnerAppCollection.AccessTokens
    );
  }

  static storagePath(app: IReffable<IPartnerApp>): string {
    return app.ref.path;
  }
}
